import React from 'react';
import { CopyableText } from 'src/shared/components';
import type {
  BatchJobStatus,
  DSMStatus,
  TerrainTileStatus,
} from 'src/shared/enums';
import { convertFromMeters } from 'src/shared/helpers';
import { lineMeasurementUnitAbbreviations } from '../constant';
import { LineMeasurementType, LineMeasurementUnit } from '../enums';
import { MeasurementInfo } from '../measurement-info';
import type { FeaturePropertiesType } from '../types';

type LineMeasurementDetailsProps = {
  featureProperties: FeaturePropertiesType;
  measurementUnit?: string;
  isLoading: boolean;
  terrainIterationId?: string | null;
  dsmStatus?: DSMStatus;
  dsmCogStatus?: BatchJobStatus;
  terrainTileStatus?: TerrainTileStatus;
};

export const LineMeasurementDetails: React.FC<LineMeasurementDetailsProps> = ({
  featureProperties,
  isLoading,
  measurementUnit,
  terrainIterationId,
  dsmStatus,
  dsmCogStatus,
  terrainTileStatus,
}) => {
  // Variables.
  const { planarDistance, surfaceDistance } = featureProperties;
  const currentMeasurementUnit =
    measurementUnit ??
    lineMeasurementUnitAbbreviations[LineMeasurementUnit.Meters];
  const distance2D = planarDistance
    ? convertFromMeters(planarDistance, currentMeasurementUnit)
    : '-';

  return (
    <div className="map-3d-feature-info-sidecard__measurement-details__line">
      <CopyableText
        header={<>{LineMeasurementType.Distance2D}:&nbsp;</>}
        value={`${distance2D} ${currentMeasurementUnit}`}
        showCopyIcon={!!planarDistance}
        isLoading={isLoading}
      />

      <MeasurementInfo
        label={<>{LineMeasurementType.SurfaceDistance3D}:&nbsp;</>}
        value={
          surfaceDistance
            ? convertFromMeters(surfaceDistance, currentMeasurementUnit)
            : null
        }
        isLoading={isLoading}
        unit={measurementUnit}
        terrainIterationId={terrainIterationId}
        dsmStatus={dsmStatus}
        dsmCogStatus={dsmCogStatus}
        terrainTileStatus={terrainTileStatus}
      />
    </div>
  );
};
